import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SideNavHideService {
  hideSideNav: boolean = false;

  toggleSideNav(): void {
    this.hideSideNav = !this.hideSideNav;
  }

  hide() {
    this.hideSideNav = true;
  }

  show() {
    this.hideSideNav = false;
  }
}
